import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { Router } from "@angular/router";
import { SnackbarService } from "../../../../components/snackbar/snackbar.service";
import { ThemeFormComponent } from "../../components/theme-form/theme-form.component";
import { ThemeFormValue } from "../../models/theme.model";
import { ThemesApiService } from "../../services/themes.api.service";

@Component({
    selector: "app-create-theme",
    templateUrl: "./create-theme.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ThemeFormComponent]
})
export class CreateThemeComponent {
    private readonly themesService = inject(ThemesApiService);
    private readonly router = inject(Router);
    private readonly snackbarService = inject(SnackbarService);

    // In-flight guard so the primary can't double-submit. TODO: fold into a fuller
    // submitting/loading treatment (e.g. spinner) when that's designed.
    readonly submitting = signal(false);

    onSubmit(value: ThemeFormValue): void {
        this.submitting.set(true);
        this.themesService.createTheme(value).subscribe({
            next: () => {
                this.snackbarService.show("Theme created.", "success");
                void this.router.navigate(["/admin/themes"]);
            },
            error: () => {
                this.submitting.set(false);
                this.snackbarService.show("We couldn’t save your changes. Try again.", "error");
            }
        });
    }
}
